import React from 'react';
export function FinalCTA() {
  return <section className="py-20 px-4 relative overflow-hidden bg-pink-400" data-id="element-52">
      <div className="absolute inset-0 bg-confetti opacity-30 pointer-events-none mix-blend-overlay" data-id="element-53"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center text-white" data-id="element-54">
        <h2 className="text-4xl md:text-6xl font-bold mb-6 font-baloo drop-shadow-md" data-id="element-55">
          🔥 READY TO CREATE THE PARTY OF YOUR DREAMS?
        </h2>

        <p className="text-xl md:text-2xl mb-10 font-medium opacity-90 max-w-2xl mx-auto" data-id="element-56">
          Don't let another birthday go by without the magic your little one
          deserves. For less than the cost of a helium balloon, you get access
          to everything you need.
        </p>

        <div className="bg-white text-gray-900 rounded-3xl p-8 md:p-12 shadow-2xl max-w-2xl mx-auto transform hover:scale-[1.02] transition-transform border-4 border-pink-200" data-id="element-57">
          <div className="flex items-center justify-center gap-4 mb-6" data-id="element-58">
            <span className="text-3xl text-gray-400 line-through font-bold" data-id="element-59">
              €47
            </span>
            <span className="text-6xl font-bold text-magenta font-baloo" data-id="element-60">
              €17
            </span>
          </div>

          <a href="#pricing" className="block w-full bg-pink-500 text-white font-baloo font-bold text-2xl md:text-3xl py-5 px-8 rounded-full shadow-[0_8px_0_#D81B60] hover:shadow-[0_4px_0_#D81B60] hover:translate-y-1 transition-all duration-200 mb-6" data-id="element-61">
            👇 I WANT MY MAGIC PARTY KIT 👇
          </a>

          <p className="text-sm md:text-base font-bold text-gray-500 uppercase tracking-wider" data-id="element-62">
            ⚡ Instant access · One-time payment · No subscriptions
          </p>
          <p className="text-sm text-gray-400 mt-2 italic" data-id="element-63">
            Your kit arrives in your email within minutes 🎉
          </p>
        </div>
      </div>
    </section>;
}